export const colors = {
  shared: {
    black: "#000000",
    white: "#FFFFFF"
  },
  light: {
    primary: "#E8510F",
    text: "#0C1063",
    background: "#F9D021"
  },
  dark: {
    primary: "#E8510F",
    text: "#F9D021",
    background: "#0C1063"
  }
};

export const paddingSmall = "24px";
export const paddingMedium = "72px";
export const paddingLarge = "100px";

export const xMarginMobile = "16px";

export const contentWidth = "800px";
export const contentWidthNarrow = "600px";

const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px"
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};
